(() => {
  document.querySelectorAll('.product-detail-tabs').forEach((tabs) => {
    const items = Array.from(tabs.querySelectorAll('.product-detail-tabs__item'));
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const items = Array.from(gallery.querySelectorAll(':scope > .product-gallery__item'));
    if (items.length <= 1) return;

    gallery.classList.add('is-carousel-ready');

    const viewport = document.createElement('div');
    viewport.className = 'product-gallery__viewport';

    const track = document.createElement('div');
    track.className = 'product-gallery__track';

    items.forEach((item) => track.appendChild(item));
    viewport.appendChild(track);
    gallery.appendChild(viewport);

    const controls = document.createElement('div');
    controls.className = 'product-gallery__controls';

    const previous = document.createElement('button');
    previous.className = 'product-gallery__button';
    previous.type = 'button';
    previous.title = 'Previous image';
    previous.setAttribute('aria-label', 'Previous image');
    previous.textContent = '‹';

    const next = document.createElement('button');
    next.className = 'product-gallery__button';
    next.type = 'button';
    next.title = 'Next image';
    next.setAttribute('aria-label', 'Next image');
    next.textContent = '›';

    controls.append(previous, next);
    gallery.appendChild(controls);

    const dots = document.createElement('div');
    dots.className = 'product-gallery__dots';
    const dotButtons = items.map((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'product-gallery__dot';
      dot.type = 'button';
      dot.title = `Show image ${index + 1}`;
      dot.setAttribute('aria-label', `Show image ${index + 1}`);
      dots.appendChild(dot);
      return dot;
    });
    gallery.appendChild(dots);

    let current = 0;
    let dragStart = null;

    const show = (index) => {
      current = (index + items.length) % items.length;
      track.style.transform = `translateX(${-100 * current}%)`;
      dotButtons.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === current);
      });
    };

    previous.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    dotButtons.forEach((dot, index) => dot.addEventListener('click', () => show(index)));

    viewport.addEventListener('pointerdown', (event) => {
      dragStart = event.clientX;
    });

    viewport.addEventListener('pointerup', (event) => {
      if (dragStart === null) return;
      const delta = event.clientX - dragStart;
      dragStart = null;
      if (Math.abs(delta) < 36) return;
      show(delta < 0 ? current + 1 : current - 1);
    });

    viewport.addEventListener('pointercancel', () => {
      dragStart = null;
    });

    show(0);
  });

  const masterHashTargets = new Map([
    ['conversion-kits', 'conversion-kits'],
    ['kits', 'conversion-kits'],
    ['batteries', 'batteries'],
    ['bundles', 'bundles'],
    ['parts', 'parts'],
    ['shop-all', 'shop-all'],
    ['all-products', 'shop-all']
  ]);

  const getMasterTargetFromHash = (hash) => masterHashTargets.get(hash.replace('#', '').toLowerCase());
  const normalizePath = (path) => path.replace(/\/$/, '/index.html');
  const masterLinkSelector = 'a[href*="#conversion-kits"], a[href*="#kits"], a[href*="#batteries"], a[href*="#bundles"], a[href*="#parts"], a[href*="#shop-all"], a[href*="#all-products"]';
  const getMasterTargetFromUrl = (href) => {
    try {
      return getMasterTargetFromHash(new URL(href, window.location.href).hash);
    } catch (error) {
      return undefined;
    }
  };
  const updateActiveMasterLinks = (target) => {
    document.querySelectorAll(masterLinkSelector).forEach((link) => {
      const isActive = getMasterTargetFromUrl(link.href) === target;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  document.querySelectorAll('[data-master-slider]').forEach((slider) => {
    const tabs = Array.from(slider.querySelectorAll('[data-master-target]'));
    const panels = Array.from(slider.querySelectorAll('[data-master-panel]'));
    const previous = slider.querySelector('[data-master-previous]');
    const next = slider.querySelector('[data-master-next]');
    const panelOrder = panels.map((panel) => panel.dataset.masterPanel);

    const showMasterPanel = (target, shouldScroll = false, shouldUpdateHash = false) => {
      if (!panelOrder.includes(target)) return;

      tabs.forEach((tab) => {
        const isActive = tab.dataset.masterTarget === target;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.masterPanel === target;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.querySelectorAll('.product-card').forEach((card) => card.classList.add('is-visible'));
        }
      });
      updateActiveMasterLinks(target);

      if (shouldUpdateHash) {
        history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${target}`);
      }

      if (shouldScroll) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        slider.scrollIntoView({ block: 'start', behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => showMasterPanel(tab.dataset.masterTarget, false, true));
    });

    previous?.addEventListener('click', () => {
      const activePanel = slider.querySelector('[data-master-panel].is-active')?.dataset.masterPanel || panelOrder[0];
      const activeIndex = panelOrder.indexOf(activePanel);
      showMasterPanel(panelOrder[(activeIndex - 1 + panelOrder.length) % panelOrder.length], false, true);
    });

    next?.addEventListener('click', () => {
      const activePanel = slider.querySelector('[data-master-panel].is-active')?.dataset.masterPanel || panelOrder[0];
      const activeIndex = panelOrder.indexOf(activePanel);
      showMasterPanel(panelOrder[(activeIndex + 1) % panelOrder.length], false, true);
    });

    const hashTarget = getMasterTargetFromHash(window.location.hash);
    if (hashTarget) {
      showMasterPanel(hashTarget, true, false);
    } else {
      updateActiveMasterLinks(panelOrder[0]);
    }

    window.addEventListener('hashchange', () => {
      const target = getMasterTargetFromHash(window.location.hash);
      if (target) showMasterPanel(target, true, false);
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;

      const url = new URL(link.href, window.location.href);
      const target = getMasterTargetFromHash(url.hash);
      if (!target || normalizePath(url.pathname) !== normalizePath(window.location.pathname)) return;

      event.preventDefault();
      showMasterPanel(target, true, true);
    });
  });

  if (!document.querySelector('[data-master-slider]')) {
    const hashTarget = getMasterTargetFromHash(window.location.hash);
    if (hashTarget) updateActiveMasterLinks(hashTarget);
  }

  const revealCards = Array.from(document.querySelectorAll('.product-card'));
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (revealCards.length) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealCards.forEach((card) => card.classList.add('is-visible'));
    } else {
      revealCards.forEach((card, index) => {
        card.dataset.scrollReveal = '';
        card.style.setProperty('--reveal-delay', `${(index % 6) * 70}ms`);
      });

      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, {
        threshold: 0.16,
        rootMargin: '0px 0px -60px 0px'
      });

      revealCards.forEach((card) => revealObserver.observe(card));
    }
  }

  const backToTop = document.createElement('button');
  backToTop.className = 'back-to-top';
  backToTop.type = 'button';
  backToTop.title = 'Back to top';
  backToTop.setAttribute('aria-label', 'Back to top');
  backToTop.innerHTML = '<span aria-hidden="true">&uarr;</span>';
  document.body.appendChild(backToTop);

  const updateBackToTop = () => {
    backToTop.classList.toggle('is-visible', window.scrollY > 420);
  };

  backToTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', updateBackToTop, { passive: true });
  updateBackToTop();
})();
